const map = {
	"./banner.svg": 1997,
	"./banner01.svg": 4196,
	"./banner02.svg": 7319,
	"./banner03.svg": 9782,
	"./banner04.svg": 2377,
	"./banner05.svg": 7512,
	"./banner06.svg": 6347
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7510;